import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type CartToastVariant =
    "success" | "warning" | "info" | "error" | "default";

export type CartToastActionType = "undo" | "viewCart";

export interface CartToastState {
    id: string;
    variant: CartToastVariant;
    message: string;
    actionLabel?: string;
    actionType?: CartToastActionType;
    undoProductId?: number;
    showIcon?: boolean;
}

interface CartToastSliceState {
    toast: CartToastState | null;
}

const initialState: CartToastSliceState = {
    toast: null,
};

const cartToastSlice = createSlice({
    name: "cartToast",
    initialState,
    reducers: {
        showCartToast: (
            state,
            action: PayloadAction<Omit<CartToastState, "id">>,
        ) => {
            state.toast = {
                ...action.payload,
                id: `${Date.now()}`,
            };
        },
        clearCartToast: (state) => {
            state.toast = null;
        },
    },
});

export const cartToastReducer = cartToastSlice.reducer;
export const { showCartToast, clearCartToast } = cartToastSlice.actions;
